import { Col, message, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import apiNetCore from '../../../../../../../../services/apiNetCore';
import { Spin } from '../../../../../../../../styles/global';
import { LoadingContainer } from './styles';

const TagRemovidoForm = ({ tagJustificativa, setTagJustificativa }) => {
  const [loadingMotivos, setLoadingMotivos] = useState(false);
  const [motivosCancelamento, setMotivosCancelamento] = useState([]);
  const motivosFormatados = useMemo(
    () => motivosCancelamento.map(motivo => motivo.descricao),
    [motivosCancelamento]
  );

  useEffect(() => {
    const optionsIdMotivoCancelamentoOc = [2, 3, 6, 8, 9];
    const onLoad = async () => {
      setLoadingMotivos(true);
      try {
        const { data } = await apiNetCore.get('/MotivoCancelamentoOc/GetAll');
        const filterOptions = data.filter(elem =>
          optionsIdMotivoCancelamentoOc.includes(elem.idMotivoCancelamentoOc)
        );

        setMotivosCancelamento(filterOptions);
      } catch (error) {
        message.error(
          'Houve um erro ao obter lista de motivos de cancelamento oc'
        );
      }
      setLoadingMotivos(false);
    };
    onLoad();
  }, []);

  return (
    <>
      <br />
      <p>Escolha abaixo a justificativa para a remoção do motorista:</p>
      <Col>
        {loadingMotivos ? (
          <LoadingContainer>
            <p>Carregando justificativas</p>
            <Spin />
          </LoadingContainer>
        ) : (
          <Select
            data-testid="select-justificativa"
            style={{ width: '80%' }}
            defaultValue={tagJustificativa}
            showSearch
            onChange={justificativa => setTagJustificativa(justificativa)}
          >
            {motivosFormatados.map(justificativa => (
              <Select.Option
                key={justificativa}
                title={justificativa}
                value={justificativa}
              >
                {justificativa}
              </Select.Option>
            ))}
          </Select>
        )}
      </Col>
    </>
  );
};

TagRemovidoForm.propTypes = {
  tagJustificativa: PropTypes.string,
  setTagJustificativa: PropTypes.func.isRequired,
};

TagRemovidoForm.defaultProps = {
  tagJustificativa: '',
};

export default TagRemovidoForm;
